export enum DocumentsTabState {
  TCS = 'T&Cs',
}
